export default __webpack_public_path__ + "static/media/workplace.ad6e7739.png";